import {createLazyFileRoute} from '@tanstack/react-router'

import Addresses from '@/views/Account/Addresses/Addresses'

export const Route = createLazyFileRoute('/_account/addresses/')({
  component: Addresses,
})
